document.addEventListener("DOMContentLoaded", function () {
  // ----- CONFIG -----
  const VALID_PROMOS = {
    JAN2026: {
      discountCode: "JAN2026",
      // message: "January Promo Applied! Enjoy your savings through the 15th."
    },
  };

  const PARAM_NAME = "promo";
  const STORAGE_KEY = "active_promo_code";
  const APPLIED_FLAG = "promo_discount_applied";
  const ANNOUNCEMENT_SELECTOR = "#promo-announcement-bar";

  // ----- HELPERS -----

  function getQueryParam(name) {
    const url = new URL(window.location.href);
    return url.searchParams.get(name);
  }

  function isWithinDateRange(startDay, endDay) {
    const today = new Date();
    const day = today.getDate();
    console.log("day", day);
    return day >= startDay && day <= endDay;
  }

  function savePromoToStorage(code) {
    localStorage.setItem(STORAGE_KEY, code);
  }

  function getSavedPromo() {
    return localStorage.getItem(STORAGE_KEY);
  }

  function markDiscountApplied(code) {
    sessionStorage.setItem(`${APPLIED_FLAG}_${code}`, "true");
  }

  function isDiscountAlreadyApplied(code) {
    return sessionStorage.getItem(`${APPLIED_FLAG}_${code}`) === "true";
  }

  function showAnnouncement(message) {
    const bar = document.querySelector(ANNOUNCEMENT_SELECTOR);
    if (!bar) return;
    // bar.textContent = message;
    bar.style.display = "block";
    bar.offsetHeight;

    console.log("showAnnouncement");
  }

  function applyDiscountRedirect(code) {
    if (isDiscountAlreadyApplied(code)) return;

    markDiscountApplied(code);

    const currentUrl = window.location.pathname + window.location.search;
    const redirectUrl = `/discount/${code}?redirect=${encodeURIComponent(currentUrl)}`;

    window.location.href = redirectUrl;
  }

  // ----- MAIN FLOW -----

  const promoParam = getQueryParam(PARAM_NAME);
  const savedPromo = getSavedPromo();

  let promoCode = null;

  // Check URL promo param
  if (promoParam && VALID_PROMOS[promoParam] && isWithinDateRange(1, 14)) {
    promoCode = promoParam;
    savePromoToStorage(promoParam);
  }
  // Or fallback to persisted promo
  else if (savedPromo && VALID_PROMOS[savedPromo] && isWithinDateRange(1, 14)) {
    promoCode = savedPromo;
  } else {
    // Invalid or expired → clear stored promo
    localStorage.removeItem(STORAGE_KEY);
  }

  if (!promoCode) return;

  const promo = VALID_PROMOS[promoCode];

  // Show announcement bar
  showAnnouncement(promo.message);

  // Apply discount redirect if not applied this session
  applyDiscountRedirect(promo.discountCode);
});
